import { render, staticRenderFns } from "./ManagementMailing.vue?vue&type=template&id=4e41943a&scoped=true&"
import script from "./ManagementMailing.vue?vue&type=script&lang=ts&"
export * from "./ManagementMailing.vue?vue&type=script&lang=ts&"
import style0 from "./ManagementMailing.vue?vue&type=style&index=0&id=4e41943a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e41943a",
  null
  
)

export default component.exports